const initialState = {
    toggle:false,
    isLoading:false,
    isSearch:false,
    domain:[],
    text:'',
    uploadedFiles:[],
    qa:[]
}

const generateQaReducers= (state = initialState, { type, payload }) => {
  switch (type) {
  case 'switchToggleGQA':
    state =  { ...state, toggle:payload };
    return state;
  case 'isLoadingGQA':
    state =  { ...state, isLoading:payload };
    return state;
  case 'isSearchGQA': 
    state =  { ...state, isSearch:payload };
    return state;
  case 'domainGQA':
    state =  { ...state, domain:payload };
    return state;
    case 'textGQA': 
    state =  { ...state, text:payload };
    return state;
    case 'qaGQA':
        state =  { ...state, qa:payload };
        return state;
    case 'uploadFilesGQA':
      state =  { ...state, uploadedFiles:payload };
      return state;
  default:
    return state
  }
}

export default generateQaReducers;